var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-form__r-09" },
    [
      _c(
        "FormWrapper",
        { attrs: { validator: _vm.$v.form } },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8" }, [
              _c("p", {
                staticClass: "mbm",
                domProps: { innerHTML: _vm._s(_vm.$t("form_r09_introtext")) },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("IcFormContactName", {
            model: {
              value: _vm.form.name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactEmail", {
            attrs: { withAgreement: true },
            on: {
              "update:agreement": function ($event) {
                _vm.form.emailAgreement = $event
              },
              "update:pollAgreement": function ($event) {
                _vm.form.pollAgreement = $event
              },
            },
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactPhone", {
            model: {
              value: _vm.form.phone,
              callback: function ($$v) {
                _vm.$set(_vm.form, "phone", $$v)
              },
              expression: "form.phone",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactAddress", {
            model: {
              value: _vm.form.address,
              callback: function ($$v) {
                _vm.$set(_vm.form, "address", $$v)
              },
              expression: "form.address",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactConnection", {
            attrs: {
              withDelay: true,
              minDate: _vm.minDate,
              endDate: _vm.endDate,
            },
            model: {
              value: _vm.form.connection,
              callback: function ($$v) {
                _vm.$set(_vm.form, "connection", $$v)
              },
              expression: "form.connection",
            },
          }),
          _vm._v(" "),
          _c("h3", [_vm._v("Wiadomość")]),
          _vm._v(" "),
          _c("IcFormContactMessage", {
            model: {
              value: _vm.form.message,
              callback: function ($$v) {
                _vm.$set(_vm.form, "message", $$v)
              },
              expression: "form.message",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactBank", {
            model: {
              value: _vm.form.bank,
              callback: function ($$v) {
                _vm.$set(_vm.form, "bank", $$v)
              },
              expression: "form.bank",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactFiles", {
            model: {
              value: _vm.form.files,
              callback: function ($$v) {
                _vm.$set(_vm.form, "files", $$v)
              },
              expression: "form.files",
            },
          }),
          _vm._v(" "),
          _c("IcFormAgreements", {
            attrs: {
              text: false,
              header: false,
              modal: true,
              name: "agreement",
              is_visible: false,
              value: true,
              label: _vm.$t("label_agreement_checkbox"),
              content: "form_agreement_r",
            },
            model: {
              value: _vm.form.agreement,
              callback: function ($$v) {
                _vm.$set(_vm.form, "agreement", $$v)
              },
              expression: "form.agreement",
            },
          }),
          _vm._v(" "),
          _c("IcFormButtons", {
            attrs: {
              sending: _vm.isSending,
              error: _vm.isError,
              message: _vm.errorMessage,
            },
            on: { click: _vm.submit },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }